import React, { useState } from "react";
import { TbSettings } from "react-icons/tb";
import { PiPaintBrushBroadFill } from "react-icons/pi";
import { BsStars } from "react-icons/bs";

import { Menus } from "../../../../components/Menus";
import General from "../Settings/General";
import AI from "../Settings/AI";
import ChatInterface from "../Settings/ChatInterface";

const options = [
  {
    key: "general",
    label: "General",
    icon: <TbSettings size={20} />,
  },
  {
    key: "ai",
    label: "AI",
    icon: <BsStars size={20} />,
  },
  {
    key: "chatinterface",
    label: "Chat Interface",
    icon: <PiPaintBrushBroadFill size={20} />,
  },
];

const Settings = ({ userId, botId, state, dispatch }) => {
  const [activeOption, setActiveOption] = useState("general"); // fixed typo

  return (
    <div className="flex flex-1 gap-4 flex-col relative p-6 py-4">
      <h1 className="text-2xl font-semibold text-gray-600 my-3">Settings</h1>
      <div className="flex gap-3 sm:gap-5 md:gap-10 flex-col md:flex-row">
        {/* Menus component is assumed to be defined elsewhere */}
        <Menus
          options={options}
          setActiveOption={setActiveOption}
          activeOption={activeOption}
        />
        {/* Optional: render content based on activeOption */}
        <div className="flex-1">
          {activeOption === "general" && (
            <General state={state} dispatch={dispatch} />
          )}
          {activeOption === "ai" && <AI botId={botId} />}
          {activeOption === "chatinterface" && (
            <ChatInterface selectedBot={state?.selectedBot} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
